<template>
    <div>
        <vs-dialog v-model="active">
            <template #header>
                <h4 class="not-margin">
                    Enviar correo electrónico
                </h4>
            </template>


            <div class="con-form">
                <div class="form-group">
                    <form autocomplete="off">
                        <label for="asunto">Asunto</label>
                        <input v-model="asunto" type="text" class="form-control" id="asunto" placeholder="Asunto">
                        <div style="color:red;" v-if="errorFields.includes('asunto')">
                            <small>Requerido</small>
                        </div>
                    </form>
                </div>
                <div class="form-group">
                    <form autocomplete="off">
                        <label for="mensaje">Mensaje</label>
                        <textarea v-model="mensaje" class="form-control" id="mensaje" rows="3"></textarea>
                    </form>
                </div>
            </div>

            <template #footer>
                <div class="footer-dialog d-flex">
                    <vs-button danger block @click="borrar()" style="width: 30%;">
                    Cancelar
                    </vs-button>
                    <vs-button success class="ml-auto" block @click="postEnviarCorreoProceso()" style="width: 30%;">
                    Aceptar
                    </vs-button>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
import landing from '../../../../../../api/requests/landing'
export default {
    props:[
      'value',
      'correo'
    ],
    data(){
        return{
            active: false,
            asunto: '',
            mensaje: '',
            errorFields:[]
        }
    },
    methods:{
        borrar(){
            this.asunto = ''
            this.mensaje = ''
            this.active = false           
        },
        sanityForm () {
            this.errorFields = []
            if (!this.asunto) {
                this.errorFields.push('asunto')
            }
            if (!this.errorFields.length){
                const params = {
                    asunto: this.asunto,
                    mensaje: this.mensaje,
                    prospecto_id: this.correo.prospecto_id,
                    status_id: this.correo.status_id
                }
                return params
            } else {
                return null
            }
        },
        async postEnviarCorreoProceso(){
            const info = this.sanityForm()
            if(info){
                try{
                    const payload = Object.assign(info)
                    const response = await landing.postEnviarCorreoProceso(payload)
                    this.borrar()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Exito',
                        text: `Se envio el correo correctamente.`
                    })
                }catch(error){
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un error',
                        text: `Favor de contactar al administrador.`
                    })
                }
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>